<template>
  <div id="portal">
    <Loading v-if="loading" class="p-8" />
    <router-view v-else />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { isSubdomain } from '@/router/helpers'

export default {
  name: 'Portal',

  metaInfo () {
    const accountName = this.portal.name
    return {
      title: 'Customer Portal',
      titleTemplate: `%s | ${accountName}`
    }
  },

  created () {
    this.getPortal()
  },

  computed: {
    ...mapState(['colors', 'portal']),
  },

  data () {
    return {
      loading: true
    }
  },

  methods: {
    ...mapMutations(['setPortal']),

    async getPortal () {
      try {
        let response
        
        if (isSubdomain()) {
          const subdomain = window.location.hostname.split('.')[0]
          response = await this.$api.get(`portal/`, { params: { account: subdomain } })
        } else if (this.$route.params.account) {
          response = await this.$api.get(`portal/`, { params: { account: this.$route.params.account } })
        } else if (this.$route.params.trackingCode) {
          response = await this.$api.get(`portal/`, { params: { code: this.$route.params.trackingCode } })
        } else if (this.$route.params.id) {
          response = await this.$api.get(`portal/`, { params: { form: this.$route.params.account } })
        }

        this.setPortal(response.data.portal)
        document.documentElement.style.setProperty('--accent-color', this.colors[response.data.portal.color])

        if (this.$route.name === 'Portal') {
          if (this.$cookies.get('customer_token')) {
            this.$router.push({ name: 'CustomerBookingList' })
          } else {
            this.$router.push({ name: 'CustomerLogin' })
          }
        }
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.$nextTick(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

<style lang="postcss">
@import "../assets/css/_accents";
</style>